/* eslint-disable */
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

/**
 * Returns a Material React Table localization object built from
 * the active react-i18next language. Supports EN, ES, and CA.
 * Add/edit translations in src/locales/{lang}/translation.json
 * under the "mrt_*" keys.
 */
const useMRTLocalization = () => {
  const { t, i18n } = useTranslation();

  return useMemo(
    () => ({
      actions: t("mrt_actions"),
      and: t("mrt_and"),
      cancel: t("mrt_cancel"),
      changeFilterMode: t("mrt_changeFilterMode"),
      changeSearchMode: t("mrt_changeSearchMode"),
      clearFilter: t("mrt_clearFilter"),
      clearSearch: t("mrt_clearSearch"),
      clearSelection: t("mrt_clearSelection"),
      clearSort: t("mrt_clearSort"),
      clickToCopy: t("mrt_clickToCopy"),
      copy: t("mrt_copy"),
      collapse: t("mrt_collapse"),
      collapseAll: t("mrt_collapseAll"),
      columnActions: t("mrt_columnActions"),
      copiedToClipboard: t("mrt_copiedToClipboard"),
      dropToGroupBy: t("mrt_dropToGroupBy"),
      edit: t("mrt_edit"),
      expand: t("mrt_expand"),
      expandAll: t("mrt_expandAll"),
      filterArrIncludes: t("mrt_filterArrIncludes"),
      filterArrIncludesAll: t("mrt_filterArrIncludesAll"),
      filterArrIncludesSome: t("mrt_filterArrIncludesSome"),
      filterBetween: t("mrt_filterBetween"),
      filterBetweenInclusive: t("mrt_filterBetweenInclusive"),
      filterByColumn: t("mrt_filterByColumn"),
      filterContains: t("mrt_filterContains"),
      filterEmpty: t("mrt_filterEmpty"),
      filterEndsWith: t("mrt_filterEndsWith"),
      filterEquals: t("mrt_filterEquals"),
      filterEqualsString: t("mrt_filterEqualsString"),
      filterFuzzy: t("mrt_filterFuzzy"),
      filterGreaterThan: t("mrt_filterGreaterThan"),
      filterGreaterThanOrEqualTo: t("mrt_filterGreaterThanOrEqualTo"),
      filterInNumberRange: t("mrt_filterInNumberRange"),
      filterIncludesString: t("mrt_filterIncludesString"),
      filterIncludesStringSensitive: t("mrt_filterIncludesStringSensitive"),
      filterLessThan: t("mrt_filterLessThan"),
      filterLessThanOrEqualTo: t("mrt_filterLessThanOrEqualTo"),
      filterMode: t("mrt_filterMode"),
      filterNotEmpty: t("mrt_filterNotEmpty"),
      filterNotEquals: t("mrt_filterNotEquals"),
      filterStartsWith: t("mrt_filterStartsWith"),
      filterWeakEquals: t("mrt_filterWeakEquals"),
      filteringByColumn: t("mrt_filteringByColumn"),
      goToFirstPage: t("mrt_goToFirstPage"),
      goToLastPage: t("mrt_goToLastPage"),
      goToNextPage: t("mrt_goToNextPage"),
      goToPreviousPage: t("mrt_goToPreviousPage"),
      grab: t("mrt_grab"),
      groupByColumn: t("mrt_groupByColumn"),
      groupedBy: t("mrt_groupedBy"),
      hideAll: t("mrt_hideAll"),
      hideColumn: t("mrt_hideColumn"),
      max: t("mrt_max"),
      min: t("mrt_min"),
      move: t("mrt_move"),
      noRecordsToDisplay: t("mrt_noRecordsToDisplay"),
      noResultsFound: t("mrt_noResultsFound"),
      of: t("mrt_of"),
      or: t("mrt_or"),
      pin: t("mrt_pin"),
      pinToLeft: t("mrt_pinToLeft"),
      pinToRight: t("mrt_pinToRight"),
      resetColumnSize: t("mrt_resetColumnSize"),
      resetOrder: t("mrt_resetOrder"),
      rowActions: t("mrt_rowActions"),
      rowNumber: t("mrt_rowNumber"),
      rowNumbers: t("mrt_rowNumbers"),
      rowsPerPage: t("mrt_rowsPerPage"),
      save: t("mrt_save"),
      search: t("mrt_search"),
      select: t("mrt_select"),
      selectedCountOfRowCountRowsSelected: t(
        "mrt_selectedCountOfRowCountRowsSelected"
      ),
      showAll: t("mrt_showAll"),
      showAllColumns: t("mrt_showAllColumns"),
      showHideColumns: t("mrt_showHideColumns"),
      showHideFilters: t("mrt_showHideFilters"),
      showHideSearch: t("mrt_showHideSearch"),
      sortByColumnAsc: t("mrt_sortByColumnAsc"),
      sortByColumnDesc: t("mrt_sortByColumnDesc"),
      sortedByColumnAsc: t("mrt_sortedByColumnAsc"),
      sortedByColumnDesc: t("mrt_sortedByColumnDesc"),
      thenBy: t("mrt_thenBy"),
      toggleDensity: t("mrt_toggleDensity"),
      toggleFullScreen: t("mrt_toggleFullScreen"),
      toggleSelectAll: t("mrt_toggleSelectAll"),
      toggleSelectRow: t("mrt_toggleSelectRow"),
      toggleVisibility: t("mrt_toggleVisibility"),
      ungroupByColumn: t("mrt_ungroupByColumn"),
      unpin: t("mrt_unpin"),
      unpinAll: t("mrt_unpinAll"),
    }),
    // Re-compute whenever language changes
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [i18n.language]
  );
};

export default useMRTLocalization;
